import styled from 'styled-components'
import Img from 'gatsby-image'

const getImageWidth = bgWidth => {
  if (bgWidth === '100%') {
    return '100vw'
  } else if (bgWidth === '50%') {
    return '50vw'
  } else if (bgWidth === '25%') {
    return '75vw'
  }
  return '100vw'
}

const getTitleSize = size => {
  if (size === 'small') {
    return '2.25rem'
  } else if (size === 'medium') {
    return '3.25rem'
  } else if (size === 'large') {
    return '4rem'
  }
  return '4rem'
}

const getTypeAlign = pos => {
  if (pos === 'Center') {
    return 'center'
  } else if (pos === 'Left') {
    return 'flex-start'
  } else if (pos === 'Right') {
    return 'flex-end'
  }
  return 'center'
}

const getHeadlinePadding = width => {
  if (width === '25%') {
    return '12rem 2rem 8rem 2rem'
  } else if (width === '50%') {
    return '12rem 4rem 8rem 4rem'
  } else if (width === '100%') {
    return '12rem 4rem 8rem 4rem'
  }
  return '12rem 4rem 8rem 4rem'
}

export const Container = styled.div`
  background: ${props =>
    props.color === 'Dark'
      ? props.theme.colors.black
      : props.theme.colors.white};
  color: ${props =>
    props.color === 'Dark'
      ? props.theme.colors.white
      : props.theme.colors.black};
  height: ${props => (props.fullHeight ? '100vh' : 'auto')};
  display: flex;
  position: relative;
  .gatsby-image-outer-wrapper {
    flex-grow: 1;
  }
  @media only screen and (max-width: 62rem) {
    flex-direction: column;
    height: auto;
  }
`

export const HeadlineImage = styled(Img)`
  flex: none;
  max-width: ${props => getImageWidth(props.width)};
  width: 100%;
  height: 100%;
  @media only screen and (max-width: 62rem) {
    max-width: 100%;
    min-height: ${props => getImageWidth(props.width)};
  }
`

export const HeadlineText = styled.div`
  padding: ${props => getHeadlinePadding(props.width)};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: ${props => props.width};
  text-align: ${props => props.textAlignment};
  flex-shrink: 0;
  min-width: 18rem;
  order: ${props => (props.pos === 'Right' ? '0' : '-1')};
  @media only screen and (max-width: 62rem) {
    width: 100%;
    padding-top: 8rem;
    padding-bottom: 4rem;
  }
  @media only screen and (max-width: 48rem) {
    padding-left: 2rem;
    padding-right: 2rem;
  }
`

export const Title = styled.h1`
  font-family: 'GT Super Display', serif;
  font-size: ${props => getTitleSize(props.size)};
  line-height: 1.1;
  font-weight: 400;
  max-width: 16em;
  align-self: ${props => getTypeAlign(props.pos)};
  @media only screen and (max-width: 80rem) {
    font-size: ${props => `calc( 0.75 * ${getTitleSize(props.size)} )`};
  }
`

export const Type = styled.span`
  font-family: 'IBM Plex Mono', sans-serif;
  font-size: 0.875rem;
  text-transform: uppercase;
`

export const Subject = styled.div`
  max-width: 15rem;
  align-self: ${props => getTypeAlign(props.pos)};
`

export const SubjectText = styled.span`
  display: block;
  margin: 0 auto;
  margin-bottom: ${props => (props.name ? '-0.75rem' : '0')};
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: ${props => (props.name ? '1rem' : '0.875rem')};
  opacity: ${props => (props.name ? '1' : '0.5')};
`

export const IconWrapper = styled.div`
  position: absolute;
  margin: 1rem;
  bottom: 0;
  left: ${props => (props.pos ? '50%' : '0')};
  &:hover div {
    opacity: 1;
  }
`

export const Disclaimer = styled.div`
  background: ${props =>
    props.color === 'Dark'
      ? props.theme.colors.black
      : props.theme.colors.white};
  color: ${props =>
    props.color === 'Dark'
      ? props.theme.colors.white
      : props.theme.colors.black};
  padding: 1rem 2rem;
  width: 24rem;
  position: absolute;
  bottom: 1.5rem;
  left: 1.5rem;
  opacity: 0;
  transition: 0.5s;
  pointer-events: none;
  border: 1px solid;
`
